







import Vue from 'vue';
import VueCompositionAPI, {defineComponent} from '@vue/composition-api';
import {RouterAliases} from '@/router/routerAliases';
import PilotEnds from '@common/pilot-ends.vue';

Vue.use(VueCompositionAPI);

export default defineComponent({
  name: 'AmexMyTripsHeader',
  components: {
    PilotEnds,
  },
  setup(_, {root}) {
    const discover = () => {
      // @ts-ignore
      root.$router.push({name: RouterAliases.DISCOVERY_VIEW});
    };

    const isAmex = process.env.VUE_APP_THEME === 'AMEX';

    return {
      isAmex,
      discover,
    };
  },
});
